export const AVERAGE_TORQUE_CODE = "averagetorque";
export const MAXIMUM_TORQUE_CODE = "maximumtorque";
export const AVERAGE_INPUT_SPEED_CODE = "averageinputdrivespeed";
export const LIMITING_SPEED_CODE = "limitingspeed";
export const TILTING_STIFFNESS_CODE = "tiltingstiffness";
